import React from "react";
import { Circle, CheckCircle2, XCircle, AlertCircle, Cloud, ArchiveX } from "lucide-react";

const MAP = {
  new: { label: "New", cls: "bg-blue-500/15 text-blue-300", icon: Circle },
  active: { label: "Active", cls: "bg-emerald-500/15 text-emerald-400", icon: Circle },
  weakening: { label: "Weakening", cls: "bg-amber-500/15 text-amber-300", icon: AlertCircle },
  stale: { label: "Stale", cls: "bg-zinc-500/15 text-zinc-400", icon: Cloud },
  invalidated: { label: "Invalidated", cls: "bg-rose-500/15 text-rose-400", icon: XCircle },
  market_closed: { label: "Market closed", cls: "bg-zinc-500/15 text-zinc-400", icon: ArchiveX },
  resolved_successful: { label: "Resolved · Correct", cls: "bg-emerald-500/20 text-emerald-300", icon: CheckCircle2 },
  resolved_unsuccessful: { label: "Resolved · Incorrect", cls: "bg-rose-500/15 text-rose-400", icon: XCircle },
  insufficient_data: { label: "Insufficient data", cls: "bg-zinc-500/15 text-zinc-400", icon: AlertCircle },
};

export default function LifecycleBadge({ status = "active", testid }) {
  const m = MAP[status] || MAP.active;
  const Icon = m.icon;
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-1 rounded-sm px-1.5 py-0.5 text-[10px] uppercase tracking-wider ${m.cls}`}
    >
      <Icon size={10} /> {m.label}
    </span>
  );
}
